import axios from '@/common/axios'
import store from '@/store'
import router from '@/router'

const generalMiddleware = function(to, from, next) {
    // Start our vue-progressbar
    router.app.$Progress.start()

    // To set the title of each route
    document.title = to.meta.title

    return next()
}

const getDatetimeMiddleware = async function(to, from, next) {
    // Set global program date
    let result
    let serverDate
    try {
        result = await axios.get('/datetime')
        serverDate = result.data.message
        await store.dispatch('datetime/setDate', serverDate)
    } catch (error) {
        // console.log('error: ', error)
    }

    return next()
}

const userActionMiddleware = async function(to, from, next) {
    // Grab the accessToken and refreshToken. Dealing with the localStorage and Vuex has been tricky,
    // so we'll just set everything here at the top of the waterfall.
    let accessToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null
    let refreshToken = localStorage.getItem('refreshToken') ? localStorage.getItem('refreshToken') : null

    // What we're accounting for is the instance of a reload, because up until then the user object will be
    // present if they've already logged in. So if an accessToken is present let's set the user object
    // and their access/refresh tokens.
    if (accessToken) {
        await store.dispatch('user/setUserAndTokens', {accessToken: accessToken, refreshToken: refreshToken})
    }

    // If the user's not logged in do not allow into protected pages.
    if (to.meta.requiresAuth && !store.getters['user/user']) {
        return next({name: 'home'})
    }

    return next()
}

export {generalMiddleware, getDatetimeMiddleware, userActionMiddleware}